import { useEffect, useState } from "react"
import { ADD_GSTIN, GET_USER_GSTIN, SET_DEFAULT_GSTIN } from "../../Utils/constant"
import { useSelector } from "react-redux"
import API from "../../ApiConfig"
import styles from "../../components/DashBoard/ProfileForm.module.css"
import cogoToast from "cogo-toast-react-17-fix"
import AnimatedLoader from "../../components/AnimationLoader"
const AddDefaultGstIn=({setGstinPopup})=>{


    const [gstinInput, setGstinInput]=useState("")
    const [confirmGstinInput, setConfirmGstIn]=useState("")
    const [loading, setLoading]=useState(false)
    const [EnterGSTIN, setEnterGSTIN]=useState(false)
    const [showGSTINList, setShowGSTINList]=useState(true)
    const [GSTINList, setGSTINList]=useState([])
  
  const [isSetAsDefault, setIsSetAsDefault]=useState(false)
    const User=useSelector(state=>state.User)
  
    const[gstinError, setGstinError]=useState("")
    const AddGSTIN=()=>{
        if (gstinInput === "") {
            setGstinError("Enter GSTIN");
        } 
        else if (confirmGstinInput === "") {
            setGstinError("Confirm GSTIN");
        } 
        else if (gstinInput.length !== 15) {
            setGstinError("Enter valid GSTIN");
        } 
        else if (confirmGstinInput !== gstinInput) {
            setGstinError("Confirm GSTIN not matched, try again");
        }
        else{
            setGstinError("")
        setLoading(true)
        let apiData={
            user_id:User.user_id,
            gstin:gstinInput,
            set_is_default:isSetAsDefault
        }
        API.post(ADD_GSTIN, apiData)
        .then(res=>{
            if(res.data.status==200){
                setLoading(false)
                setGstinInput("")
                setConfirmGstIn("")
                setIsSetAsDefault(false)
                setEnterGSTIN(false)
                getUsergstin()
            }
            
        })
        .catch(err=>{
            setLoading(false)
            setGstinError(err.response?.data?.message|| "Something went wrong")
  
        })}
  
    }



  useEffect(()=>{
    getUsergstin()
  },[])
  
    const getUsergstin=()=>{
      API.get(GET_USER_GSTIN+User.user_id)
      .then(res=>{
        if(res.data.status==200){
          setShowGSTINList(true)
          setGSTINList(res.data.data)
        }
        
      })
      .catch(err=>{
        setGstinError(err.reponse.data.message)
      })
    }
    const setAsDefault=(gstinId)=>{
      let apiData={
        user_id:User.user_id,
        gstin_id:gstinId
      }
      API.put(SET_DEFAULT_GSTIN,apiData)
      .then(res=>{
        if(res.data.status==200){
          setGstinPopup(false)
          cogoToast.success(res.data.message)
          window.location.reload()
        }
  
      })
      .catch(err=>{
        setGstinError(err.response.data.message)
        
      })
    }
    return(
  
    (loading?<AnimatedLoader loadingText={"Loading..."} isOpen={loading}/>:
        EnterGSTIN ?
      <div className="relative z-10 w-[28rem] max-w-full rounded-2xl bg-white p-6 shadow-lg">
  {gstinError&&
  <div
          style={{
            backgroundColor: "#fee2e2",
            color: "#b91c1c",
            padding: "0.75rem 1rem",
            borderRadius: "8px",
            marginBottom: "1rem",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          {gstinError}
        </div>}
    <header className="mb-4 flex items-center gap-3">
  <div className="flex-1">
  
  <p className="text-lg text-slate-600">
    Please enter a valid 15-character GSTIN.
  </p>
  </div>
  </header>
  
  {/* GSTIN input */}
  <div className="mb-4">
  <label>Enter GSTIN</label>
  <div style={{margin:"10px, 0px"}}>
  <input
  type="text"
  value={gstinInput}
  onChange={(e) => {setGstinInput(e.target.value.toUpperCase());
    if(gstinError){
        setGstinError("")
    }
  }}
  placeholder="Enter GSTIN (e.g. 27ABCDE1234F1Z5)"
  maxLength={15}
  className="rounded-md border px-3 py-2 text-sm focus:outline-none"
  style={{width:"75%", margin:"4px 0px", border:"1px solid rgb(206, 200,200)"}}
  />
  {gstinInput.includes(" ") && (
  <p className="text-sm text-red-500">
    GSTIN cannot contain spaces.
  </p>
  )}
  </div>
  </div>
  <div className="mb-4">
  <label>Confirm GSTIN</label>
  <div>
  <input
  type="text"
  value={confirmGstinInput}
  onChange={(e) => {setConfirmGstIn(e.target.value.toUpperCase());
    if(gstinError){
        setGstinError("")
    }
  }}
  placeholder="Confirm GSTIN.."
  maxLength={15}
  className="rounded-md border px-3 py-2 text-sm focus:outline-none"
  style={{width:"75%", margin:"4px 0px", border:"1px solid, rgb(206, 200, 200)"}}
  />
  </div>
  {confirmGstinInput.includes(" ") && (
  <p className="text-sm text-red-500">
    GSTIN cannot contain spaces.
  </p>
  )}
  </div>
  {/* <div>
    <label style={{display:"flex",alignItems:"center"}}>
      <>
      <input
          type="checkbox"
          checked={isSetAsDefault}
          onChange={(e) => setIsSetAsDefault(e.target.checked)}
          aria-label="Set as default GSTIN"
        />
        <span style={{ marginLeft: "8px" }}>Set as default</span>
      </>
    </label>
  </div> */}
  <footer className="mt-6 flex justify-end gap-3">
  
      <button
        type="button"
        onClick={()=>AddGSTIN()}
        className="btn btn-primary"
      >
        Add
      </button>
    </footer>
  </div>: showGSTINList?
  <div style={{margin:"15px", height:"400px", overflowY:"scroll"}}>
  {GSTINList && GSTINList.map((item,index)=>(
  <div key={item.id} style={{width:"inherit", margin:"10px"}} className="input" onClick={()=>{setAsDefault(item.id)}}>
    <span style={{fontSize:"14px", color:"green"}}> {`${item.is_default? "Default":""}`}</span>
    <label className={styles.gstinList}>
    <>
  <input type="radio" name="gstin" value={item.gstin} checked={item.is_default} />
  <div style={{width:"100%"}}>
  <div style={{fontSize:"18px", fontWeight:"700", padding:"10px 0px"}}>{`${item.legal_name}`}</div>
  <div style={{display:"flex", justifyContent:"space-between"}}>
  <span>{item.gstin}</span>
  <span style={{color:item.gstin_status=="Active"?"green":"red"}}>{item.gstin_status}</span>
  </div>
  </div>
  </>
  </label>
  </div>
  ))}
  <div>
  <button className="btn btn-primary" onClick={()=>setEnterGSTIN(true)}>Add New</button>
  </div>
  </div>:null)
  )}
  export default AddDefaultGstIn